module.exports = __webpack_public_path__ + "static/media/secureBadgeImg.221d1ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/secureBadgeImg.png
// module id = 13857
// module chunks = 0